import { CommonModule } from '@angular/common';
import { Component, computed } from '@angular/core';
import { EventDto } from '@millionshow/api-client';
import { Icon, ModalBasement, ModalContainer } from '@millionshow/client-libs';
import { formatDateRangeShort } from '../../../utils/date-formatter';
import { RouterLink } from '@angular/router';

interface CalendarEventModalProps {
  date: Date;
  events: EventDto[];
}

@Component({
  selector: 'app-calendar-event-modal',
  templateUrl: './calendar-event.modal.html',
  imports: [CommonModule, ModalContainer, Icon, RouterLink],
})
export class CalendarEventModal extends ModalBasement<CalendarEventModalProps> {
  formatDateRangeShort = formatDateRangeShort;

  date = computed(() => this.props()?.date);
  events = computed(() => this.props()?.events || []);
}
